import { useState, useEffect, useRef } from 'react';

function toDisplay(iso) {
  if (!iso) return '';
  const parts = iso.split('-');
  if (parts.length === 3) return `${parts[2]}/${parts[1]}/${parts[0]}`;
  return iso;
}

function toISO(text) {
  const parts = text.split('/');
  if (parts.length === 3 && parts[2].length === 4 && parts[1].length === 2 && parts[0].length === 2)
    return `${parts[2]}-${parts[1]}-${parts[0]}`;
  return '';
}

/**
 * Date input that shows dd/mm/yyyy to the user.
 * value/onChange use YYYY-MM-DD (same as <input type="date">).
 * Calendar icon opens the native date picker.
 */
export default function DateInput({ value, onChange, className, disabled, required, style, min, max }) {
  const dateRef = useRef();
  const [text, setText] = useState(toDisplay(value));

  useEffect(() => { setText(toDisplay(value)); }, [value]);

  const handleText = (e) => {
    let raw = e.target.value.replace(/[^\d/]/g, '');
    // Auto-insert slashes after dd and mm
    const digits = raw.replace(/\//g, '');
    let formatted = digits.slice(0, 2);
    if (digits.length > 2) formatted += '/' + digits.slice(2, 4);
    if (digits.length > 4) formatted += '/' + digits.slice(4, 8);
    setText(formatted);
    const iso = toISO(formatted);
    if (iso) onChange({ target: { value: iso } });
    else if (!formatted) onChange({ target: { value: '' } });
  };

  const handlePickerChange = (e) => {
    onChange(e);
    setText(toDisplay(e.target.value));
  };

  return (
    <div style={{ position: 'relative', display: 'inline-flex', alignItems: 'center', width: '100%', ...style }}>
      <input
        className={className}
        type="text"
        value={text}
        onChange={handleText}
        placeholder="dd/mm/yyyy"
        maxLength={10}
        disabled={disabled}
        required={required}
        style={{ width: '100%', paddingRight: 30 }}
      />
      {/* Hidden native date picker — only the calendar icon area is clickable */}
      <input
        ref={dateRef}
        type="date"
        value={value || ''}
        onChange={handlePickerChange}
        disabled={disabled}
        min={min}
        max={max}
        tabIndex={-1}
        style={{ position: 'absolute', right: 0, top: 0, bottom: 0, width: 32,
                 opacity: 0, cursor: 'pointer', zIndex: 1 }}
      />
      <span style={{ position: 'absolute', right: 8, color: '#888', fontSize: 13,
                     pointerEvents: 'none', zIndex: 2, lineHeight: 1 }}>📅</span>
    </div>
  );
}
